import { createContext } from 'react'

import { AsyncControlsProps, defaultState } from '../../utils'
import RedeemRequest from '../Redeem/RedeemRequest'

const RequestsContext = createContext<AsyncControlsProps<RedeemRequest[]>>(defaultState)
export default RequestsContext
